import React, { useEffect, useState } from "react";
import * as Request from "../commons/request";
import * as Types from "../commons/typeDTO";
import * as String from "../commons/string";
import * as Common from "../commons/common";
import * as Utils from "../utils/utils";
import { Button, Col, Row, Modal, Divider, Space, Form, Tooltip } from "antd";
import { InfoCircleFilled } from "@ant-design/icons";

import { useAsyncAxios, utilAxiosWithAuth } from "../utils/customAxios";
import ModalAddRentPayment from "./ModalAddRentPayment";
import { ColumnsType } from "antd/lib/table";
import DataTable from "./DataTable";
import moment from "moment";

import styles from "../pages/RentManagement/ReservationManagement.module.css";

export type AddPaymentType = {
    rent: Types.RentDto;
    paymentMethod?: string;
    paidDate?: string;
    rentPaymentType: string;
    amount: number;
    basicPrice: number;
    adjustedPrice: number;
    memo?: string;
};

function RentPaymentViewer({ rent, onUpdateRentInfo }: { rent: Types.RentDto; onUpdateRentInfo: () => void }) {
    const [openModalAddRentPayment, setOpenModalAddRentPayment] = useState(false);
    const [rentPayments, setRentPayments] = useState<Array<Types.RentPaymentDto>>([]);
    const [updateRentPayments, setUpdateRentPayments] = useState<Types.RentPaymentDto>();

    const [reservationPayment, setReservationPayment] = useState<Types.RentPaymentDto>();
    const [otherPayments, setOtherPayments] = useState<Array<Types.RentPaymentDto>>([]);

    const [amountAdditional, setAmountAdditional] = useState(0);
    const [amountAdditionalNotPaid, setAmountAdditionalNotPaid] = useState(0);

    const [amountTotal, setAmountTotal] = useState(0);

    useEffect(() => {
        rent !== undefined && requestGetRentInfo();
    }, [rent]);

    const requestAxiosGetRentInfo = async () => {
        const response = await utilAxiosWithAuth().get(Request.RENT_URL + rent?.rentId);
        return response.data;
    };

    const {
        loading: loadingGetRentInfo,
        error: errorGetRentInfo,
        data: resultGetRentInfo,
        execute: requestGetRentInfo,
    } = useAsyncAxios(requestAxiosGetRentInfo);

    useEffect(() => {
        if (resultGetRentInfo === null) return;
        console.log("resultGetRentInfo", resultGetRentInfo);

        if (resultGetRentInfo.rent.rentPayments !== undefined && resultGetRentInfo.rent.rentPayments !== null)
            setRentPayments(resultGetRentInfo.rent.rentPayments);
    }, [resultGetRentInfo]);

    useEffect(() => {
        if (errorGetRentInfo === null) return;
        console.log("errorGetRentInfo", errorGetRentInfo);
    }, [errorGetRentInfo]);

    const requestAxiosAddPayment = async (payment: AddPaymentType) => {
        const response = await utilAxiosWithAuth().post(Request.RENT_PAYMENT_ADD_URL, payment);
        return response.data;
    };

    const { loading: loadingAddPayment, error: errorAddPayment, data: resultAddPayment, execute: requestAddPayment } = useAsyncAxios(requestAxiosAddPayment);

    useEffect(() => {
        if (resultAddPayment === null) return;
        console.log("resultAddPayment", resultAddPayment);
        // rent !== undefined && requestGetRentInfo();
        onUpdateRentInfo();
    }, [resultAddPayment]);

    useEffect(() => {
        if (errorAddPayment === null) return;
        console.log("errorAddPayment", errorAddPayment);
    }, [errorAddPayment]);

    const requestAxiosUpdatePayment = async (payment: Types.RentPaymentDto) => {
        const response = await utilAxiosWithAuth().put(Request.RENT_PAYMENT_URL + payment.rentPaymentId, payment);
        return response.data;
    };

    const {
        loading: loadingUpdatePayment,
        error: errorUpdatePayment,
        data: resultUpdatePayment,
        execute: requestUpdatePayment,
    } = useAsyncAxios(requestAxiosUpdatePayment);

    useEffect(() => {
        if (resultUpdatePayment === null) return;
        console.log("resultUpdatePayment", resultUpdatePayment);
        // rent !== undefined && requestGetRentInfo();
        onUpdateRentInfo();
    }, [resultUpdatePayment]);

    useEffect(() => {
        if (errorUpdatePayment === null) return;
        console.log("errorUpdatePayment", errorUpdatePayment);
    }, [errorUpdatePayment]);

    useEffect(() => {
        console.log("rentPayments", rentPayments);
        if (rentPayments.length > 0) {
            const reservations = rentPayments.filter((rent) => rent.rentPaymentType === "RENT");
            const others = rentPayments.filter((rent) => rent.rentPaymentType !== "RENT");
            if (reservations.length > 0) setReservationPayment(reservations[0]);
            setOtherPayments(others);

            let additionalPaymentAmount = 0;
            let notPaidPaymentAmount = 0;
            others.forEach((payment) => {
                if (payment.paidDate) additionalPaymentAmount += payment.amount;
                else notPaidPaymentAmount += payment.amount;
            });
            setAmountAdditional(additionalPaymentAmount);
            setAmountAdditionalNotPaid(notPaidPaymentAmount);

            let totalAmount = 0;
            if (reservations.length > 0) totalAmount = reservations[0].amount + additionalPaymentAmount - (reservations[0].paymentImp?.cancelAmount || 0);
            setAmountTotal(totalAmount);
        }
    }, [rentPayments]);

    const onChangedPayment = (type: string, values: any) => {
        if (rent === undefined) {
            setOpenModalAddRentPayment(false);
            return;
        }

        if (type === "update" && updateRentPayments) {
            requestUpdatePayment(values);
        } else if (type === "add") {
            requestAddPayment(values);
        }

        setUpdateRentPayments(undefined);
        setOpenModalAddRentPayment(false);
    };

    const onUpdateRentPayment = (rentPayment: Types.RentPaymentDto) => {
        setUpdateRentPayments(rentPayment);
        setOpenModalAddRentPayment(true);
    };

    const onDeleteRentPayment = (rentPayment: Types.RentPaymentDto) => {
        Modal.confirm({
            title: "결제 삭제",
            content: "결제를 삭제하시겠습니까?",
            okText: "확인",
            onOk() {
                if (rentPayment.rentPaymentType === "PAID_ITEM") {
                    requestDeletePaidItem(rent.rentId, rentPayment.rentPaymentItem.rentPaymentItemName);
                }
                requestDeletePayment(rentPayment);
            },
            cancelText: "취소",
            onCancel() {},
            centered: true,
        });
    };

    const requestAxiosDeletePayment = async (rentPayment: Types.RentPaymentDto) => {
        const response = await utilAxiosWithAuth().delete(Request.RENT_PAYMENT_URL + rentPayment.rentPaymentId);
        return response.data;
    };

    const {
        loading: loadingDeletePayment,
        error: errorDeletePayment,
        data: resultDeletePayment,
        execute: requestDeletePayment,
    } = useAsyncAxios(requestAxiosDeletePayment);

    useEffect(() => {
        if (resultDeletePayment === null) return;
        console.log("resultDeletePayment", resultDeletePayment);
        //rent !== undefined && requestGetRentInfo();
        onUpdateRentInfo();
    }, [resultDeletePayment]);

    useEffect(() => {
        if (errorDeletePayment === null) return;
        console.log("errorDeletePayment", errorDeletePayment);
    }, [errorDeletePayment]);

    const requestAxiosDeletePaidItem = async (rentId: number, rentPaidItemName: string) => {
        const response = await utilAxiosWithAuth().put(Request.RENT_URL + rentId, {
            rentPaidItems: rent.rentPaidItems?.filter((item) => item.rentPaidItemName !== rentPaidItemName),
        });
        return response.data;
    };

    const {
        loading: loadingDeletePaidItem,
        error: errorDeletePaidItem,
        data: resultDeletePaidItem,
        execute: requestDeletePaidItem,
    } = useAsyncAxios(requestAxiosDeletePaidItem);

    useEffect(() => {
        if (resultDeletePaidItem === null) return;
        console.log("resultDeletePaidItem", resultDeletePaidItem);
    }, [resultDeletePaidItem]);

    useEffect(() => {
        if (errorDeletePaidItem === null) return;
        console.log("errorDeletePaidItem", errorDeletePaidItem);
    }, [errorDeletePaidItem]);

    const columns: ColumnsType<Types.RentPaymentDto> = [
        {
            align: "center",
            title: "번호",
            dataIndex: "num",
            key: "rentPaymentId",
            render: (item, record, index) => <>{otherPayments && otherPayments.indexOf(record) + 1}</>,
        },
        {
            align: "center",
            title: "구분",
            dataIndex: "paymentType",
            key: "paymentType",
            render: (_, row) => {
                return row?.memo?.includes("[기타]") ? "기타" : Utils.convertRentPaymentType(row);
            },
        },
        {
            align: "center",
            title: "세부항목",
            dataIndex: "paymentType",
            key: "paymentType",
            render: (_, row) => {
                return row?.memo?.includes("[기타]") ? row?.memo?.slice(4, row?.memo?.length) : Utils.convertRentPaymentItem(rent, row);
            },
        },
        {
            align: "center",
            title: "책정요금",
            dataIndex: "basicPrice",
            key: "basicPrice",
            sorter: (a, b, sortOrder) => Utils.sortString(a.basicPrice.toString().valueOf(), b.basicPrice.toString().valueOf(), sortOrder),
            render: (_, row) => {
                if (row.basicPrice !== undefined && row.basicPrice !== null) {
                    return Utils.convertCurrencyKorean(row.basicPrice);
                }
                return String.dash;
            },
        },
        {
            align: "center",
            title: "조정요금",
            dataIndex: "adjustedPrice",
            key: "adjustedPrice",
            sorter: (a, b, sortOrder) => Utils.sortString(a.adjustedPrice.toString().valueOf(), b.adjustedPrice.toString().valueOf(), sortOrder),
            render: (_, row) => {
                if (row.adjustedPrice !== undefined && row.adjustedPrice !== null) {
                    return Utils.convertCurrencyKorean(row.adjustedPrice);
                }
                return String.dash;
            },
        },
        {
            align: "center",
            title: "최종정산요금",
            dataIndex: "amount",
            key: "amount",
            sorter: (a, b, sortOrder) => Utils.sortString(a.amount.toString().valueOf(), b.amount.toString().valueOf(), sortOrder),
            render: (_, row) => {
                if (row.amount !== undefined && row.amount !== null) {
                    return Utils.convertCurrencyKorean(row.amount);
                }
                return String.dash;
            },
        },
        {
            align: "center",
            title: "정산방법",
            dataIndex: "paymentMethod",
            key: "paymentMethod",
            render: (_, row) => {
                return Utils.convertRentPaymentMethod(row);
            },
        },

        {
            align: "center",
            title: "정산등록일",
            dataIndex: "paidDate",
            key: "paidDate",
            sorter: (a, b, sortOrder) => Utils.sortString(a.paidDate.valueOf(), b.paidDate.valueOf(), sortOrder),
            render: (_, row) => {
                return row.createdDate ? Utils.utcToLocalTime(row.createdDate, Common.FORMAT_DATE_TIME) : String.dash;
            },
        },
        {
            align: "center",
            title: "정산일",
            dataIndex: "paidDate",
            key: "paidDate",
            sorter: (a, b, sortOrder) => Utils.sortString(a.paidDate.valueOf(), b.paidDate.valueOf(), sortOrder),
            render: (_, row) => {
                if (row.paidDate) {
                    return Utils.utcToLocalTime(row.paidDate, Common.FORMAT_DATE_TIME);
                } else return String.dash;
            },
        },
        {
            align: "center",
            title: "수정",
            dataIndex: "update",
            key: "update",
            render: (_, row) => {
                return (
                    <>
                        <Button
                            shape="round"
                            size="small"
                            onClick={(e) => {
                                e.stopPropagation();
                                onUpdateRentPayment(row);
                            }}
                        >
                            수정
                        </Button>
                    </>
                );
            },
        },
        {
            align: "center",
            title: "삭제",
            dataIndex: "delete",
            key: "delete",
            render: (_, row) => {
                return (
                    <>
                        <Button
                            danger
                            shape="round"
                            size="small"
                            onClick={(e) => {
                                e.stopPropagation();
                                onDeleteRentPayment(row);
                            }}
                        >
                            삭제
                        </Button>
                    </>
                );
            },
        },
    ];

    return (
        <div>
            <Row justify={"space-between"}>
                <Col span={6}>
                    <Divider className={styles.subTitle} orientation="left">
                        <span>정산 정보</span>
                    </Divider>
                </Col>
                <Col style={{ alignContent: "center" }}>
                    <Button onClick={() => setOpenModalAddRentPayment(true)}>추가</Button>
                </Col>
            </Row>
            <Space direction="vertical" size={20} style={{ width: "100%" }}>
                <Form>
                    <Row>
                        <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                            <Form.Item className="searchForm" label="다날주문번호">
                                <span>{reservationPayment ? reservationPayment.paymentImp?.impUid : String.dash}</span>
                            </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                            <Form.Item className="searchForm" label="예약금액">
                                <span>{reservationPayment ? Utils.convertCurrency(reservationPayment.amount) : String.dash}</span>
                            </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                            <Form.Item className="searchForm" label="결제일시">
                                <span>{reservationPayment ? Utils.utcToLocalTime(reservationPayment.paidDate, Common.FORMAT_DATE_TIME) : String.dash}</span>
                            </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                            <Form.Item className="searchForm" label="추가요금">
                                <span>{Utils.convertCurrencyKorean(amountAdditional + amountAdditionalNotPaid)}</span>
                            </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                            <Form.Item className="searchForm" label="결제카드">
                                {reservationPayment ? (
                                    rent.rentStatus === "DURING_PAYMENT" ? (
                                        <span style={{ color: "red" }}>{Utils.getRentStatus(rent)}</span>
                                    ) : (
                                        <span>{(reservationPayment.paymentImp?.cardName || "") + " " + (reservationPayment.paymentImp?.cardNumber || "")}</span>
                                    )
                                ) : (
                                    <span>{String.dash}</span>
                                )}
                            </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                            <Form.Item className="searchForm" label="취소금액">
                                <span>
                                    <span>{reservationPayment ? Utils.convertCurrency(reservationPayment.paymentImp?.cancelAmount) : String.dash}</span>
                                </span>
                            </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                            <Form.Item className="searchForm" label="사용쿠폰">
                                <span>{rent.userCoupon?.coupon?.couponName || String.dash}</span>
                            </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                            <Form.Item className="searchForm" label="미정산금">
                                <span style={{ color: "red" }}>{Utils.convertCurrencyKorean(amountAdditionalNotPaid)}</span>
                            </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                            <Form.Item className="searchForm searchLastRow" label="중복쿠폰">
                                <span>{rent.userMultiCoupon?.coupon?.couponName || String.dash}</span>
                            </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                            <Form.Item className="searchForm searchLastRow" label="총 정산요금">
                                <Space style={{ width: "100%", justifyContent: "space-between" }}>
                                    <span>{Utils.convertCurrencyKorean(amountTotal)}</span>
                                    <Tooltip title="미정산금 제외">
                                        <InfoCircleFilled />
                                    </Tooltip>
                                </Space>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
                <DataTable hasScroll={false} columns={columns} rowKey="rentPaymentId" dataSource={otherPayments} />
            </Space>
            {openModalAddRentPayment && (
                <ModalAddRentPayment
                    rent={rent}
                    rentPayment={updateRentPayments}
                    open={openModalAddRentPayment}
                    onChangedOpen={(open: boolean) => {
                        setOpenModalAddRentPayment(open);
                        setUpdateRentPayments(undefined);
                    }}
                    onChangedPayment={onChangedPayment}
                />
            )}
        </div>
    );
}

export default RentPaymentViewer;
